// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--VgGD6","complaint_content":"dece2e673c--complaint_content--MtoZH","button":"dece2e673c--button--cFvKM"};